exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attachment__caption {\n  display: none;\n}\n.question figure.attachment, .reference figure.attachment, .solution figure.attachment {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n.question div, .solution div, .reference div {\n  margin-bottom: 0.75rem;\n}\n.question div br, .solution div br, .reference div br {\n  margin-bottom: 0.75rem;\n  display: block;\n  content: ' ';\n}\n", ""]);

// exports
